var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-section"},[_c('b-field',{staticClass:"input-field",attrs:{"label":""}},[_c('FilterConfigListEditor',{attrs:{"errors":_vm.errors,"default-time-range":_vm.defaultTimeRange,"default-time-range-label":_vm.defaultTimeRangeLabel},model:{value:(_vm.inputs),callback:function ($$v) {_vm.inputs=$$v},expression:"inputs"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }